import React from 'react';
import CustomTable, { IColumn } from './CustomTable';
import { Input, Typography } from '@mui/joy';
import { IIndex } from '../interface/IIndex';

type Props = {
  indexes: Partial<IIndex>[];
  onEdit: (indexId: number, key: keyof IIndex, value: string) => void;
  edit: boolean;
};

const IndexTable = ({ indexes, onEdit, edit }: Props) => {
  const columns: IColumn<IIndex>[] = [
    {
      id: 'name',
      disablePadding: false,
      label: 'Name',
      numeric: false,
      dataIndex: 'name',
      width: 150,
    },
    {
      id: 'prefix',
      disablePadding: false,
      label: 'Prefix',
      numeric: false,
      dataIndex: 'prefix',
      width: 150,
      render: (row) =>
        edit ? (
          <Input value={row.prefix} size='sm' onChange={(e) => onEdit(row.indexId, 'prefix', e.target.value)} />
        ) : (
          <Typography>{row.prefix}</Typography>
        ),
    },
    {
      id: 'index',
      disablePadding: false,
      label: 'Index',
      numeric: true,
      dataIndex: 'index',
      width: 150,
      render: (row) =>
        edit ? (
          <Input type='number' value={row.index} size='sm' onChange={(e) => onEdit(row.indexId, 'index', e.target.value)} />
        ) : (
          <Typography>{row.index}</Typography>
        ),
    },
    {
      id: 'suffix',
      disablePadding: false,
      label: 'Suffix',
      numeric: false,
      dataIndex: 'suffix',
      width: 150,
      render: (row) =>
        edit ? (
          <Input value={row.suffix} size='sm' onChange={(e) => onEdit(row.indexId, 'suffix', e.target.value)} />
        ) : (
          <Typography>{row.suffix}</Typography>
        ),
    },
  ];

  return (
    <React.Fragment>
      <CustomTable data={indexes} idKey='indexId' columns={columns} pagination={false} perPage={10} />
    </React.Fragment>
  );
};

export default IndexTable;
